import z from "zod";

export const TopolTagSchema = z.union([
  z.literal("h1"),
  z.literal("h2"),
  z.literal("h3"),
  z.literal("p"),
  z.literal("ul"),
  z.literal("ol"),
  z.literal("li"),
  z.literal("a"),
  z.literal("mj-button"),
  z.literal("mj-product"),
  z.literal("mj-class"),
  z.literal(".rounded>table"),
]);

export const TopolTagAttributesSchema = z.union([
  z.literal("font-family"),
  z.literal("font-size"),
  z.literal("font-weight"),
  z.literal("font-style"),
  z.literal("letter-spacing"),
  z.literal("text-transform"),
  z.literal("text-decoration"),
  z.literal("background-color"),
  z.literal("color"),
  z.literal("border-collapse"),
]);
